import React, { useState } from 'react';

import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EntryPopup from './entryPopup';
import AddMenu from './addMenu';
import EntryTable from './entryTable';

export default function AppContents() {
  const [addMenu, setAddMenu] = useState(false);
  const [updater, triggerUpdate] = useState(0);
  const [entryPopup, openPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const handleMenu = (mybool) =>{
    setAddMenu(true);
    console.log("inhandlemenu")
  }
  return (
    <div className="App">
       <div className='website-container'>
        <h1>my app :)</h1>
        <EntryTable updater={updater}  entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        <div style={{ display: entryPopup ? 'block' : 'none' }}>
          <EntryPopup  entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        </div>
        <Fab id="addbtn" color="primary" aria-label="add" onClick={()=>handleMenu(true)}>
          <AddIcon />
        </Fab>
        <div className='menucontainer' style={{ display: addMenu ? 'block' : 'none' }}>
          <AddMenu addMenu={addMenu} setAddMenu={setAddMenu} updater={updater} triggerUpdate={triggerUpdate}/>
        </div>
       </div>
    </div>
  );
}